import { TileRow } from './styled';
import ScrollLoader from '@components/ScrollLoader';

export interface TileViewProps {
  keys: string[];
  onLoadMore?: (number: number) => void;
  children: (key: string, index: number) => null | JSX.Element;
}

const TileView = ({ keys, children, onLoadMore }: TileViewProps) => (
  <ScrollLoader handleLoadRequest={() => onLoadMore && onLoadMore(keys.length)}>
    {() => (
      <TileRow data-cy-id="tile-view">
        {keys.map((key, index) => children(key, index))}
      </TileRow>
    )}
  </ScrollLoader>
);

export default TileView;
